import Button from "@mui/material/Button";
import { alpha } from "@mui/material/styles";
import React from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import * as globalStyles from "../../../utils/GlobalStyles";
import IconView from "../IconView";

function ButtonView(props) {
  const {
    text,
    arialabel,
    onClick,
    disabled = false,
    withLinkStyle = false,
    color = withLinkStyle ? "secondary" : "primary",
    customButtonBackgroundColor,
    customButtonHoverColor = customButtonBackgroundColor,
    to,
    danger,
    externalUrl,
    leftIcon,
    rightIcon,
    size,
    capitalize = true,
    textAlign = "center",
    isTitleButton = false,
    style, // for overriding style
    textStyle, // for customizing the <span> element containing {text},
  } = props;

  const variant = withLinkStyle ? null : "contained";

  const onClickAction = (() => {
    if (externalUrl || to) {
      return;
    } else {
      return onClick;
    }
  })();

  const titleStyle = isTitleButton ? styles.sectionHeader : {};
  const capitalizationStyle = capitalize ? {} : { textTransform: "none" };

  // This ternary provides the color rendered on button hover if any custom color is supplied.
  // If only a background color is supplied, the hover color is a faded version of this color (see props).
  // If only a hovered color is supplied, the color will only be applied/faded when hovered.
  // If both colors are supplied, both will be respected, though the hover color will be faded.
  const buttonHoverColor = customButtonHoverColor
    ? { backgroundColor: alpha(customButtonHoverColor, 0.7) }
    : {};

  return (
    <Button
      component={to ? Link : undefined}
      to={to}
      target={externalUrl ? "_blank" : undefined}
      rel={externalUrl ? "noopener" : undefined}
      aria-label={arialabel}
      href={externalUrl}
      style={{
        boxShadow: withLinkStyle
          ? undefined
          : "0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
        ...style,
      }}
      size={size}
      color={color}
      disabled={!!disabled}
      variant={variant}
      onClick={onClickAction}
    >
      {leftIcon && <IconView {...leftIcon} />}
      <span
        style={{
          textAlign: textAlign,
          color: disabled
            ? globalStyles.colors.text3
            : color == "primary"
            ? withLinkStyle
              ? globalStyles.primaryColor
              : globalStyles.colors.text
            : danger
            ? globalStyles.redPrimaryColor
            : globalStyles.colors.text1,
          ...textStyle,
          ...titleStyle,
          ...capitalizationStyle,
        }}
      >
        {text}
      </span>
      {rightIcon && (
        <div style={rightIcon?.style ? {} : styles.rightIcon}>
          <IconView
            {...rightIcon}
            color={rightIcon.color || globalStyles.colors.text1}
          />
        </div>
      )}
    </Button>
  );
}

const styles = {
  rightIcon: { padding: "0px 10px" },
  sectionHeader: {
    color: globalStyles.colors.text3,
    textTransform: "uppercase",
    letterSpacing: "0.2em",
    fontSize: "12px",
    lineHeight: "normal",
  },
};

export default withRouter(ButtonView);
